var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        height: "100%"
      }
    },
    [
      _c(
        "div",
        { staticClass: "operations", staticStyle: { "margin-bottom": "5px" } },
        [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "showEditDialog",
                      disabled: _vm.readonly,
                      type: "primary"
                    },
                    on: {
                      click: function() {
                        return _vm.showEditDialog(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "showEditDialog",
                      disabled: _vm.readonly,
                      type: "primary"
                    },
                    on: {
                      click: function() {
                        return _vm.showEditDialog(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "remove",
                      disabled: _vm.readonly,
                      type: "danger"
                    },
                    on: { click: _vm.remove }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "side-bar": _vm.sideBarDefs,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.$t("Partners.changeServicePersonnel"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.positionType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "roleType" },
                          on: { change: _vm.roleTypeChange },
                          model: {
                            value: _vm.editDialog.form.roleType,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "roleType", $$v)
                            },
                            expression: "editDialog.form.roleType"
                          }
                        },
                        _vm._l(_vm.roleTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.businessType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "lob" },
                          on: { change: _vm.lobChange },
                          model: {
                            value: _vm.editDialog.form.lob,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "lob", $$v)
                            },
                            expression: "editDialog.form.lob"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.All"),
                              value: "ALL"
                            }
                          }),
                          _vm._l(_vm.lobs, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCargoSource,
                          expression: "showCargoSource"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "cargoSource", clearable: true },
                          model: {
                            value: _vm.editDialog.form.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "cargoSource", $$v)
                            },
                            expression: "editDialog.form.cargoSource"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.customerSpace2"),
                              value: "NC"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.customerSpace3"),
                              value: "SC"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.userName") } },
                    [
                      _c("cargo-user-select", {
                        ref: "userSelect",
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "userId",
                          "method-params": {
                            category: "role",
                            shape: _vm.getRoleTypeEnglishName(
                              _vm.editDialog.form.roleType
                            )
                          },
                          "default-value": _vm.editDialog.form.userId || "",
                          "show-custom-label-in-option": true,
                          "custom-label": _vm.userCustomLabel,
                          "init-default-option": true
                        },
                        on: {
                          change: function(p) {
                            _vm.editDialog.form.userId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultUser" },
                          model: {
                            value: _vm.editDialog.form.defaultUser,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "defaultUser", $$v)
                            },
                            expression: "editDialog.form.defaultUser"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCustomerExpandMode,
                          expression: "showCustomerExpandMode"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CustomerExpandMode")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "customerExpandMode" },
                          model: {
                            value: _vm.editDialog.form.customerExpandMode,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "customerExpandMode",
                                $$v
                              )
                            },
                            expression: "editDialog.form.customerExpandMode"
                          }
                        },
                        _vm._l(_vm.customerExpandModes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks" },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "saveSub", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }